import { exceptions } from './exceptions'

export class RequestFailedError extends Error {
  readonly url: string
  readonly status: number

  constructor(url: string, status: number) {
    super(`Request failed with ${status}: ${url}`)
    this.name = 'RequestFailedError'
    this.url = url
    this.status = status
  }
}

export async function fetchJson<T = unknown>(url: string): Promise<T> {
  const response = await fetch(url)

  if (!response.ok) throw new RequestFailedError(url, response.status)

  return (await response.json()) as T
}

export function reportLoadFailure(error: unknown) {
  exceptions.handle(error instanceof Error ? error : new Error(String(error)))
}
